<form #newModule (ngSubmit)="submit()" class="mt-4 mb-0">  

    <div class="fieldset fieldset--lg">
      <label class="legend" for="link">Vcircle Media Link <span class="requiredfield">*</span></label>
      <input type="url" name="medialink" id="medialink" class="text-field" [(ngModel)]="mediaLink" required="required">
      <button type="button" data-toggle="dropdown" aria-expanded="false" title="Vcircle media link"
        class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button>
      <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">A download link from Vcircle. The file is copied into this course's media library, so it counts towards your school's storage allowance. If the link has expired, generate a fresh one in Vcircle.</p>
      </div>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="title">Title <span class="requiredfield">*</span></label>
      <input type="text" name="title" id="title" class="text-field" [(ngModel)]="mediaTitle" required="required">
      <button type="button" data-toggle="dropdown" aria-expanded="false" title="Title"
        class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button>
      <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">The name this recording appears under in the media library.</p>
      </div>
    </div>
    <div class="d-flex justify-content-center flex-wrap gap-1.5">
      <button *ngIf="uploading; else notUploading" type="button" class="btn btn--loading m-0">redirecting in {{countdown}}</button>
      <ng-template #notUploading>
        <button [disabled]="this.mediaTitle.length <= 0 || this.mediaLink.length <= 0" type="submit" class="btn m-0">Upload</button>
      </ng-template>
    </div>
  </form>
  